<template>
  <main class="edit-area">
    <section class="edit-panel">
      <div class="panel-head">
        <div>
          <div class="method-title">
            <el-tooltip :content="$t('QuotationCenter.components.copyPasteTip')" placement="top-start">
              <span>!</span>
            </el-tooltip>
            {{ $t('QuotationCenter.components.copyPasteMethod') }}
          </div>
        </div>
        <div class="panel-actions">
          <el-button size="mini" plain icon="el-icon-back" @click="handleClose">{{ $t('QuotationCenter.components.back') }}</el-button>
          <el-button size="mini" plain icon="el-icon-plus" :disabled="adjustmentPriceDisabled" @click="onAdjustmentPrice">{{ $t('QuotationCenter.components.batchAdjustment') }}</el-button>
          <el-button size="mini" plain class="primary-plain" @click="onClear">{{ $t('QuotationCenter.components.clear') }}</el-button>
          <el-button size="mini" type="primary" class="primary-btn" :disabled="!feeItem" @click="onSave"><i class="el-icon-check"></i> {{ $t('QuotationCenter.components.save') }}</el-button>
        </div>
      </div>

      <el-form ref="priceTableForm" :model="priceTableForm" :rules="priceTableRules" class="price-table-form">
        <el-table
          ref="priceTable"
          v-loading="loading"
          :data="priceRows"
          :show-header="true"
          height="360"
          class="price-table"
          :class="{ 'price-table--ready': tablesReady }"
          border
          script
          :header-cell-style="$rowStyle.DEFAULT"
          @cell-click="handleCellClick"
        >
          <el-table-column type="index" :label="$t('QuotationCenter.serialNumber')" width="54" align="center" />
          <!-- 包裹类型：超出QUOTATION_PACKAGE_TYPE范围 报错 -->
          <el-table-column prop="packageType" :label="$t('QuotationCenter.packageType')" align="center" min-width="133">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.packageType`" :rules="priceTableRules.packageType">
                <BjSelectLov v-model="row.packageType" :option-list="QUOTATION_PACKAGE_TYPE" />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 分区：只能输入英文、数字和空格 -->
          <el-table-column prop="zone" :label="$t('QuotationCenter.zone')" align="center">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.zone`" :rules="priceTableRules.zone">
                <el-input v-model="row.zone" size="small" :placeholder="$t('inputText')" />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 起始量：最多允许保留三位小数 -->
          <el-table-column prop="startWeight" :label="$t('QuotationCenter.start')" align="center">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.startWeight`" :rules="priceTableRules.startWeight">
                <el-input v-model="row.startWeight" size="small" :placeholder="$t('inputText')" @input="validateWeightRow($index)" />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 结束量：最多允许保留三位小数 -->
          <el-table-column prop="endWeight" :label="$t('QuotationCenter.end')" align="center">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.endWeight`" :rules="priceTableRules.endWeight">
                <el-input v-model="row.endWeight" size="small" :placeholder="$t('inputText')" @input="validateWeightRow($index)" />
              </el-form-item>
            </template>
          </el-table-column>
           <!-- 计算方法：超出QUOTATION_CALC_METHOD范围 报错 -->
          <el-table-column prop="calcMethod" :label="$t('QuotationCenter.calcMethod')" align="center" width="200">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.calcMethod`" :rules="priceTableRules.calcMethod">
                <BjSelectLov v-model="row.calcMethod" :option-list="QUOTATION_CALC_METHOD" />
              </el-form-item>
            </template>
          </el-table-column>
           <!-- 进位单位：超出QUOTATION_CHARGE_UNIT范围 报错 -->
          <el-table-column prop="unitWeight" :label="$t('QuotationCenter.components.roundingUnit')" align="center" width="118">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.unitWeight`" :rules="priceTableRules.unitWeight">
                <el-input v-model="row.unitWeight" size="small" :placeholder="$t('inputText')" @input="validateWeightRow($index)" />
              </el-form-item>
            </template>
          </el-table-column>
          <!-- 单价：最多允许保留四位小数 -->
          <el-table-column prop="unitPrice" :label="$t('QuotationCenter.components.unitPrice')" align="center" width="95">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.unitPrice`" :rules="priceTableRules.unitPrice">
                <el-input v-model="row.unitPrice" size="small" :placeholder="$t('inputText')" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="minimumCharge" :label="$t('QuotationCenter.components.minimumCharge')" align="center" width="110">
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`priceRows.${$index}.minimumCharge`" :rules="priceTableRules.minimumCharge">
                <el-input v-model="row.minimumCharge" size="small" :placeholder="$t('inputText')" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.operationText')" align="center" width="100" fixed="right">
            <template v-slot="{ $index }">
              <el-button type="text" class="danger-text" @click="onDelete($index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <button type="button" class="add-row" @click="onAddRow">
        <i class="el-icon-plus"></i>{{ $t('QuotationCenter.components.addRow') }}
      </button>
    </section>

    <QuotationImportPanel
      ref="importPanel"
      :loading="importLoading"
      :importable="!!(feeItem && feeItem.id)"
      @closed="resetImportState"
      @confirm="confirmImport"
    />

    <el-dialog
      :title="$t('QuotationCenter.components.batchAdjustment')"
      :visible.sync="adjustmentDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @closed="resetAdjustmentForm"
    >
      <el-form ref="adjustmentForm" :model="adjustmentForm" :rules="adjustmentRules" label-position="top" class="adjustment-form">
        <el-form-item :label="$t('QuotationCenter.components.adjustmentType')" prop="type">
          <el-select v-model="adjustmentForm.type" class="full-width" size="small" @change="handleAdjustmentTypeChange">
            <el-option :label="$t('QuotationCenter.components.fixedAmountAdjustment')" value="fixed" />
            <el-option :label="$t('QuotationCenter.components.percentAdjustment')" value="percent" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="adjustmentForm.type === 'fixed'" :label="$t('QuotationCenter.components.fixedAmount')" prop="amount">
          <el-input v-model="adjustmentForm.amount" size="small" clearable :placeholder="$t('QuotationCenter.components.adjustmentPlaceholder')" />
        </el-form-item>
        <el-form-item v-if="adjustmentForm.type === 'percent'" :label="$t('QuotationCenter.components.percentAmount')" prop="percent">
          <el-input v-model="adjustmentForm.percent" size="small" clearable :placeholder="$t('QuotationCenter.components.adjustmentPlaceholder')">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="adjustmentDialogVisible = false">{{ $t('QuotationCenter.components.close') }}</el-button>
        <el-button size="small" type="primary" @click="confirmAdjustmentPrice">{{ $t('QuotationCenter.components.confirmAdjustment') }}</el-button>
      </div>
    </el-dialog>

  </main>
</template>

<script>
import { logisticApi } from '@/api';
import viewMiXin from '@/utils/view-mixin.js';
import QuotationImportPanel from './QuotationImportPanel.vue';
import {
  QUOTATION_PACKAGE_TYPE,
  QUOTATION_CALC_METHOD,
  QUOTATION_CHARGE_UNIT,
  loadQuotationOptions,
} from '@/utils/quotationOptions';

const PASTE_PACKAGE_TYPE_MAP = {
  parcel: 0,
  document: 1,
  pak: 2,
  pallet: 3,
};

const PASTE_CALC_METHOD_MAP = {
  ratetablelookup: 0,
  directratecalculation: 1,
  incrementalrating: 2,
};

const THREE_DECIMAL_PATTERN = /^\d+(\.\d{1,3})?$/;
const UNIT_PRICE_PATTERN = /^\d+(\.\d{1,4})?$/;
const TWO_DECIMAL_PATTERN = /^-?\d+(\.\d{1,2})?$/;
const NUMBER_TYPE_PATTERN = /^\d+(\.\d*)?$/;
const ADJUSTMENT_ALLOWED_CHAR_PATTERN = /^[\d.-]+$/;
const ZONE_PATTERN = /^[A-Za-z0-9 ]+$/;
const MAX_WEIGHT_VALUE = 99999.999;
const MAX_UNIT_WEIGHT_VALUE = 9.999;
const MAX_UNIT_PRICE_VALUE = 99999.9999;
export default {
  name: 'CostEditorPanel',
  components: {
    QuotationImportPanel,
  },
  mixins: [viewMiXin],
  props: {
    feeItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageName: 'BusinessQuotationDetails',
      QUOTATION_PACKAGE_TYPE,
      QUOTATION_CALC_METHOD,
      QUOTATION_CHARGE_UNIT,
      loading: false,
      tablesReady: false,
      requestId: 0,
      currentCell: null, // 当前选中的单元格
      adjustmentDialogVisible: false,
      adjustmentForm: {
        type: 'fixed',
        amount: '',
        percent: '',
      },
      importLoading: false,
      importLog: '',
      priceRows: [],
    };
  },
  computed: {
    // 批量调价按钮是否禁用：当表格中有单价为空时，禁用批量调价按钮
    adjustmentPriceDisabled() {
      return this.priceRows.some(row => this.isEmptyValue(row.unitPrice) || String(row.unitPrice).trim() === '');
    },
    // 表格数据
    priceTableForm() {
      return {
        priceRows: this.priceRows,
      };
    },
    // 表格校验规则
    priceTableRules() {
      return {
        packageType: [
          { required: true, message: this.$t('chooseText'), trigger: 'change' },
          { validator: this.validateOptionValue(QUOTATION_PACKAGE_TYPE, this.$t('QuotationCenter.components.packageTypeOutOfRange')), trigger: 'change' },
        ],
        zone: [
          { validator: this.validateZone, trigger: 'blur' },
        ],
        startWeight: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { validator: this.validateWeightValue('startWeight'), trigger: ['blur', 'change'] },
        ],
        endWeight: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { validator: this.validateWeightValue('endWeight'), trigger: ['blur', 'change'] },
        ],
        calcMethod: [
          { required: true, message: this.$t('chooseText'), trigger: 'change' },
          { validator: this.validateOptionValue(QUOTATION_CALC_METHOD, this.$t('QuotationCenter.components.calcMethodOutOfRange')), trigger: 'change' },
        ],
        unitWeight: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { validator: this.validatePattern(NUMBER_TYPE_PATTERN, this.$t('formatErrorText')), trigger: 'blur' },
          { validator: this.validatePattern(/^\d+(\.\d{1,3})?$/, this.$t('QuotationCenter.components.roundingUnitMaxThreeDecimals')), trigger: 'blur' },
          { validator: this.validateMaxValue(MAX_UNIT_WEIGHT_VALUE), trigger: 'blur' },
          { validator: this.validateUnitWeightRange, trigger: 'blur' },
          { validator: this.validateUnitWeightMultiple, trigger: 'blur' },
        ],
        unitPrice: [
          { required: true, message: this.$t('inputText'), trigger: 'blur' },
          { validator: this.validateUnitPrice, trigger: 'blur' },
        ],
        minimumCharge: [
          { validator: this.validateMinimumCharge, trigger: 'blur' },
        ],
      };
    },
    // 批量调价表单校验规则
    adjustmentRules() {
      const validateAdjustmentValue = (rule, value, callback) => {
        if (this.isEmptyValue(value)) {
          callback(new Error(this.$t('inputText')));
          return;
        }
        if (!ADJUSTMENT_ALLOWED_CHAR_PATTERN.test(String(value).trim())) {
          callback(new Error(this.$t('formatErrorText')));
          return;
        }
        if (!TWO_DECIMAL_PATTERN.test(String(value).trim())) {
          callback(new Error(this.$t('QuotationCenter.components.maxTwoDecimals')));
          return;
        }
        callback();
      };

      return {
        type: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        amount: [{ validator: validateAdjustmentValue, trigger: 'blur' }],
        percent: [{ validator: validateAdjustmentValue, trigger: 'blur' }],
      };
    },
  },
  watch: {
    // 切换费用项时，重新获取 表格数据
    feeItem: {
      immediate: true,
      handler() {
        this.getPriceRows();
      },
    },
  },
  mounted() {
    loadQuotationOptions();
    // 监听全局粘贴事件
    this.initPasteListener();

    // 为表格添加焦点样式提示
    this.$nextTick(() => {
      if (this.$refs.priceTable && this.$refs.priceTable.$el) {
        const tableEl = this.$refs.priceTable.$el;
        tableEl.style.outline = 'none';
        tableEl.setAttribute('tabindex', '0');
      }
      this.requestTableLayout({ hideBeforeLayout: true });
    });
  },
  activated() {
    this.requestTableLayout({ hideBeforeLayout: true });
  },
  beforeDestroy() {
    this.removePasteListener();
  },
  methods: {
    // 判断值是否为空
    isEmptyValue(value) {
      return value === '' || value === null || value === undefined;
    },
    resetImportState() {
      this.importLoading = false;
    },
    async confirmImport({ file, type }) {
      if (!file) {
        return;
      }
      const supplierLogisticsQuoteFeeTypeId = this.feeItem && this.feeItem.id;
      if (!supplierLogisticsQuoteFeeTypeId) {
        this.$message.warning(this.$t('QuotationCenter.feeItem'));
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      this.importLoading = true;
      try {
        const res = await logisticApi.importFeeTypeDataList({
          supplierLogisticsQuoteFeeTypeId,
          BjQuery: {
            type,
          },
          BjBody: formData,
        });
        if (!res.failed) {
          this.importLog = res.message || this.$t('toast.operationSuccessText');
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.$refs.importPanel && this.$refs.importPanel.closeDialog();
          this.getPriceRows();
        }
      } finally {
        this.importLoading = false;
      }
    },
    isValidThreeDecimalNumber(value) {
      return !this.isEmptyValue(value) && NUMBER_TYPE_PATTERN.test(String(value).trim()) && THREE_DECIMAL_PATTERN.test(String(value).trim());
    },
    toThousandInteger(value) {
      return Math.round(Number(value) * 1000);
    },
    // 将粘贴的文本进行标准化处理，去除空格、下划线和连字符，并转换为小写
    normalizePasteText(value) {
      return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, '');
    },
    // 验证值是否符合指定的正则表达式模式
    validatePattern(pattern, message) {
      return (rule, value, callback) => {
        if (this.isEmptyValue(value) || pattern.test(String(value).trim())) {
          callback();
          return;
        }
        callback(new Error(message));
      };
    },
    validateZone(rule, value, callback) {
      if (this.isEmptyValue(value) || String(value).trim() === '') {
        callback(new Error(this.$t('inputText')));
        return;
      }
      if (ZONE_PATTERN.test(String(value).trim())) {
        callback();
        return;
      }
      callback(new Error(this.$t('QuotationCenter.components.zoneOnlyNumberAndEnglish')));
    },
    validateMaxValue(max) {
      return (rule, value, callback) => {
        if (this.isEmptyValue(value) || Number(value) <= max) {
          callback();
          return;
        }
        callback(new Error(this.$t('QuotationCenter.components.maxInput', { max })));
      };
    },
    // 验证值是否在指定的选项范围内
    validateOptionValue(options, message) {
      return (rule, value, callback) => {
        if (this.isEmptyValue(value) || options.some(item => String(item.value) === String(value))) {
          callback();
          return;
        }
        callback(new Error(message));
      };
    },
    // 验证单价是否符合要求：最多保留三位小数且大于0
    validateUnitPrice(rule, value, callback) {
      if (this.isEmptyValue(value)) {
        callback();
        return;
      }
      if (!NUMBER_TYPE_PATTERN.test(String(value).trim())) {
        callback(new Error(this.$t('formatErrorText')));
        return;
      }
      if (!UNIT_PRICE_PATTERN.test(String(value).trim())) {
        callback(new Error(this.$t('QuotationCenter.components.unitPriceMaxTwoDecimals')));
        return;
      }
      if (Number(value) > MAX_UNIT_PRICE_VALUE) {
        callback(new Error(this.$t('QuotationCenter.components.maxInput', { max: MAX_UNIT_PRICE_VALUE })));
        return;
      }
      if (Number(value) <= 0) {
        callback(new Error(this.$t('QuotationCenter.components.unitPriceCannotBeZero')));
        return;
      }
      callback();
    },
    validateMinimumCharge(rule, value, callback) {
      if (this.isEmptyValue(value)) {
        callback();
        return;
      }
      if (!NUMBER_TYPE_PATTERN.test(String(value).trim())) {
        callback(new Error(this.$t('formatErrorText')));
        return;
      }
      if (!THREE_DECIMAL_PATTERN.test(String(value).trim())) {
        callback(new Error(this.$t('QuotationCenter.components.maxThreeDecimals')));
        return;
      }
      if (Number(value) <= 0) {
        callback(new Error(this.$t('QuotationCenter.components.minimumChargeMustGreaterThanZero')));
        return;
      }
      callback();
    },
    validateUnitWeightRange(rule, value, callback) {
      const row = this.getRowByRule(rule);
      if (
        !row ||
        !this.isValidThreeDecimalNumber(row.startWeight) ||
        !this.isValidThreeDecimalNumber(row.endWeight) ||
        !this.isValidThreeDecimalNumber(value)
      ) {
        callback();
        return;
      }

      const unitWeight = this.toThousandInteger(value);
      const startWeight = this.toThousandInteger(row.startWeight);
      const endWeight = this.toThousandInteger(row.endWeight);
      if (unitWeight > endWeight - startWeight) {
        callback(new Error(this.$t('QuotationCenter.components.unitWeightCannotGreaterThanWeightRange')));
        return;
      }
      callback();
    },
    validateUnitWeightMultiple(rule, value, callback) {
      const row = this.getRowByRule(rule);
      if (!row || !this.isValidThreeDecimalNumber(row.endWeight) || !this.isValidThreeDecimalNumber(value)) {
        callback();
        return;
      }

      const unitWeight = this.toThousandInteger(value);
      if (unitWeight <= 0) {
        callback();
        return;
      }

      const endWeight = this.toThousandInteger(row.endWeight);
      if (endWeight % unitWeight !== 0) {
        callback(new Error(this.$t('QuotationCenter.components.endWeightMustBeUnitWeightMultiple')));
        return;
      }
      callback();
    },
    // 根据规则获取对应的表格行数据
    getRowByRule(rule) {
      const matched = String(rule.field || '').match(/^priceRows\.(\d+)\./);
      return matched ? this.priceRows[Number(matched[1])] : null;
    },
    // 验证起始量和结束量的值是否符合要求：最多保留三位小数，且起始量不能大于结束量
    validateWeightValue(field) {
      const decimalMessage = field === 'startWeight'
        ? this.$t('QuotationCenter.components.startWeightMaxThreeDecimals')
        : this.$t('QuotationCenter.components.endWeightMaxThreeDecimals');
      return (rule, value, callback) => {
        if (!this.isEmptyValue(value) && !NUMBER_TYPE_PATTERN.test(String(value).trim())) {
          callback(new Error(this.$t('formatErrorText')));
          return;
        }
        if (!this.isEmptyValue(value) && !THREE_DECIMAL_PATTERN.test(String(value).trim())) {
          callback(new Error(decimalMessage));
          return;
        }
        if (!this.isEmptyValue(value) && Number(value) > MAX_WEIGHT_VALUE) {
          callback(new Error(this.$t('QuotationCenter.components.maxInput', { max: MAX_WEIGHT_VALUE })));
          return;
        }

        const row = this.getRowByRule(rule);
        if (
          row &&
          !this.isEmptyValue(row.startWeight) &&
          !this.isEmptyValue(row.endWeight) &&
          THREE_DECIMAL_PATTERN.test(String(row.startWeight).trim()) &&
          THREE_DECIMAL_PATTERN.test(String(row.endWeight).trim()) &&
          Number(row.startWeight) > Number(row.endWeight)
        ) {
          callback(new Error(this.$t('QuotationCenter.components.startWeightCannotGreaterEndWeight')));
          return;
        }

        callback();
      };
    },
    // 验证指定行的起始量和结束量字段
    validateWeightRow(index) {
      this.$nextTick(() => {
        if (!this.$refs.priceTableForm) {
          return;
        }
        this.$refs.priceTableForm.validateField([
          `priceRows.${index}.startWeight`,
          `priceRows.${index}.endWeight`,
          `priceRows.${index}.unitWeight`,
        ]);
      });
    },
    // 把粘贴来的值映射到对应的选项值，如果没有匹配的选项，则返回原始值
    getPasteOptionValue(value, options, aliasMap) {
      if (this.isEmptyValue(value)) {
        return '';
      }

      const rawValue = String(value).trim();
      const matchedValue = options.find(item => String(item.value) === rawValue);
      if (matchedValue) {
        return matchedValue.value;
      }

      const normalizedValue = this.normalizePasteText(rawValue);
      if (Object.prototype.hasOwnProperty.call(aliasMap, normalizedValue)) {
        return aliasMap[normalizedValue];
      }

      const matchedLabel = options.find((item) => {
        const label = this.normalizePasteText(this.$t(item.label));
        return label === normalizedValue;
      });
      return matchedLabel ? matchedLabel.value : rawValue;
    },
    // 验证整个表格数据是否符合规则
    validatePriceTable() {
      return new Promise((resolve) => {
        this.$refs.priceTableForm.validate(valid => resolve(valid));
      });
    },
    // 获取空白表格数据 默认返回5行
    getEmptyPriceRows(count = 5) {
      return Array.from({ length: count }, () => ({
        packageType: '',
        zone: '',
        startWeight: '',
        endWeight: '',
        calcMethod: '',
        unitWeight: '',
        unitPrice: '',
        minimumCharge: '',
      }));
    },
    // 返回列表页
    handleClose() {
      const page = 'BusinessQuotationDetails';
      const view = this.$route;
      const query = {
        id: this.$route.query.id,
      };
      const hasCached = this.$store.state.tagsView.cachedViews.map(e => e.name).includes(page);

      this.$store.dispatch('tagsView/closeCurrentView', view).then(() => {
        this.$router.push({ name: page, query });
        if (hasCached) {
          setTimeout(() => {
            this.$eventHub.$emit('refresh' + page, 1);
          }, 500);
        }
      });
    },
    // 批量调价
    onAdjustmentPrice() {
      this.adjustmentDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.adjustmentForm && this.$refs.adjustmentForm.clearValidate();
      });
    },
    // 批量调价 重置弹框数据
    resetAdjustmentForm() {
      this.adjustmentForm = {
        type: 'fixed',
        amount: '',
        percent: '',
      };
      this.$nextTick(() => {
        this.$refs.adjustmentForm && this.$refs.adjustmentForm.clearValidate();
      });
    },
    // 批量调价 切换加收类型时清空输入值和校验提示
    handleAdjustmentTypeChange() {
      this.adjustmentForm.amount = '';
      this.adjustmentForm.percent = '';
      this.$nextTick(() => {
        this.$refs.adjustmentForm && this.$refs.adjustmentForm.clearValidate(['amount', 'percent']);
      });
    },
    // 批量调价 验证表单
    validateAdjustmentForm() {
      return new Promise((resolve) => {
        this.$refs.adjustmentForm.validate(valid => resolve(valid));
      });
    },
    // 批量调价 格式化单价，保留四位小数
    formatUnitPrice(value) {
      const fixedValue = Math.round((value + Number.EPSILON) * 10000) / 10000;
      return String(fixedValue);
    },
    // 批量调价 计算单价
    getAdjustedUnitPrice(unitPrice) {
      const currentPrice = Number(unitPrice);
      const adjustmentValue = this.adjustmentForm.type === 'fixed'
        ? Number(this.adjustmentForm.amount)
        : Number(this.adjustmentForm.percent);

      if (this.adjustmentForm.type === 'fixed') {
        return currentPrice + adjustmentValue;
      }
      return currentPrice * (1 + adjustmentValue / 100);
    },
    // 批量调价 确认调价
    async confirmAdjustmentPrice() {
      const valid = await this.validateAdjustmentForm();
      if (!valid) {
        return;
      }

      if (this.priceRows.some(row => !this.isEmptyValue(row.unitPrice) && !UNIT_PRICE_PATTERN.test(String(row.unitPrice).trim()))) {
        this.$message.warning(this.$t('QuotationCenter.components.correctUnitPriceFirst'));
        return;
      }

      const adjustedRows = this.priceRows.map(row => ({
        ...row,
        unitPrice: this.isEmptyValue(row.unitPrice) ? row.unitPrice : this.formatUnitPrice(this.getAdjustedUnitPrice(row.unitPrice)),
      }));

      if (adjustedRows.some(row => !this.isEmptyValue(row.unitPrice) && Number(row.unitPrice) <= 0)) {
        this.$message.warning(this.$t('QuotationCenter.components.adjustedUnitPriceMustGreaterThanZero'));
        return;
      }

      this.priceRows = adjustedRows;
      this.adjustmentDialogVisible = false;
      this.requestTableLayout();
      this.$nextTick(() => {
        this.validatePriceTable();
      });
    },
    // 清空表格数据
    onClear() {
      this.priceRows = this.getEmptyPriceRows();
      this.requestTableLayout();
      this.$nextTick(() => {
        this.$refs.priceTableForm && this.$refs.priceTableForm.clearValidate();
      });
    },
    // 添加一行空白可编辑数据
    onAddRow() {
      this.priceRows.push(this.getEmptyPriceRows(1)[0]);
      this.requestTableLayout();
    },
    // 删除 表格 行数据
    onDelete(index) {
      this.priceRows.splice(index, 1);
      this.requestTableLayout();
    },
    // 根据 费用项 获取右上角表格数据
    async getPriceRows() {
      const supplierLogisticsQuoteFeeTypeId = this.feeItem && this.feeItem.id;
      // requestId: 先点击A后马上点击B, 过一会儿A才返回，如果不做保护，A 的旧数据会把 B 的数据覆盖掉
      const requestId = this.requestId + 1;
      this.requestId = requestId;

      if (!supplierLogisticsQuoteFeeTypeId) {
        this.priceRows = [];
        this.requestTableLayout();
        return;
      }

      this.loading = true;
      try {
        const res = await logisticApi.getFeeTypeDataList({ supplierLogisticsQuoteFeeTypeId });
        if (requestId === this.requestId) {
          const rows = Array.isArray(res) ? res : [];
          if (rows.length) {
            this.priceRows = rows;
          } else {
            this.onClear();
          }
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false;
          this.requestTableLayout();
        }
      }
    },
    // 记录当前选中的单元格 粘贴Excel数据时使用
    handleCellClick(row, column, cell, event) {
      this.currentCell = { row, column, cell };
    },
    getPasteRows(pastedText) {
      return pastedText.split(/\r?\n/).filter(row => row.trim());
    },
    isBatchPasteRows(rows) {
      return rows.length > 1 || (rows[0] || '').split('\t').length > 1;
    },
    getSinglePasteValue(value, field) {
      const pastedValue = String(value || '').trim();
      if (field === 'packageType') {
        return this.getPasteOptionValue(pastedValue, QUOTATION_PACKAGE_TYPE, PASTE_PACKAGE_TYPE_MAP);
      }
      if (field === 'calcMethod') {
        return this.getPasteOptionValue(pastedValue, QUOTATION_CALC_METHOD, PASTE_CALC_METHOD_MAP);
      }
      return pastedValue;
    },
    validatePastedField(row, field) {
      const rowIndex = this.priceRows.indexOf(row);
      if (rowIndex < 0 || !this.$refs.priceTableForm) {
        return;
      }
      if (field === 'startWeight' || field === 'endWeight') {
        this.validateWeightRow(rowIndex);
        return;
      }
      this.$nextTick(() => {
        this.$refs.priceTableForm.validateField(`priceRows.${rowIndex}.${field}`);
      });
    },
    pasteSingleValue(value) {
      const { row, column } = this.currentCell || {};
      const field = column && column.property;
      if (!row || !field || !Object.prototype.hasOwnProperty.call(row, field)) {
        return false;
      }
      row[field] = this.getSinglePasteValue(value, field);
      this.validatePastedField(row, field);
      return true;
    },
    // 粘贴Excel数据到表格
    handlePaste(event) {
      // 只在表格区域内触发粘贴
      if (!this.currentCell || !this.$refs.priceTable) {
        return;
      }

      event.preventDefault();

      // 获取剪贴板数据
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');

      if (!pastedText) {
        return;
      }

      // 解析Excel粘贴的数据（制表符分隔的行数据）
      const rows = this.getPasteRows(pastedText);

      if (rows.length === 0) {
        return;
      }

      // 清空原有数据
      if (!this.isBatchPasteRows(rows)) {
        this.pasteSingleValue(rows[0]);
        return;
      }

      this.priceRows = [];

      // 解析每一行数据
      const newRows = rows.map((row, index) => {
        const cells = row.split('\t');
        return {
          index: index + 1,
          packageType: this.getPasteOptionValue(cells[0], QUOTATION_PACKAGE_TYPE, PASTE_PACKAGE_TYPE_MAP), // 包裹类型
          zone: cells[1] || '', // 分区
          startWeight: cells[2] || '', // 起始量
          endWeight: cells[3] || '', // 结束量
          calcMethod: this.getPasteOptionValue(cells[4], QUOTATION_CALC_METHOD, PASTE_CALC_METHOD_MAP), // 计算方法
          unitWeight: cells[5] || '', // 进位单位
          unitPrice: cells[6] || '', // 单价
          minimumCharge: cells[7] || '',
        };
      });

      this.priceRows = newRows;
      this.requestTableLayout();
      this.$nextTick(() => {
        this.validatePriceTable();
      });

      this.$message.success(this.$t('QuotationCenter.components.pasteSuccess', { count: newRows.length }));
    },

    // 获取保存的表格数据
    getSavePriceRows() {
      return this.priceRows.map(row => ({
        id: row.id || null,
        packageType: row.packageType,
        zone: this.isEmptyValue(row.zone) ? row.zone : String(row.zone).trim(),
        startWeight: row.startWeight,
        endWeight: row.endWeight,
        calcMethod: row.calcMethod,
        unitWeight: row.unitWeight,
        unitPrice: row.unitPrice,
        minimumCharge: row.minimumCharge,
      }));
    },
    // 保存表格数据
    async onSave() {
      // 如果左侧费用项为空，则不允许保存
      if (!this.feeItem) {
        return;
      }
      const valid = await this.validatePriceTable();
      if (!valid) {
        return;
      }
      const supplierLogisticsQuoteFeeTypeId = this.feeItem && this.feeItem.id;
      const res = await logisticApi.confirmFeeTypeDataList({
        supplierLogisticsQuoteFeeTypeId,
        BjBody: this.getSavePriceRows(),
      });
      if (!res.failed) {
        this.$message.success(this.$t('toast.operationSuccessText'));
        this.getPriceRows();
      }
    },
    // 监听全局粘贴事件
    initPasteListener() {
      document.addEventListener('paste', this.handlePaste);
    },
    // 移除全局粘贴事件监听
    removePasteListener() {
      document.removeEventListener('paste', this.handlePaste);
    },
    // 解决表头抖动
    requestTableLayout(options = {}) {
      if (options.hideBeforeLayout) {
        this.tablesReady = false;
      }
      this.$nextTick(() => {
        const requestFrame = window.requestAnimationFrame || (callback => window.setTimeout(callback, 16));
        requestFrame(() => {
          requestFrame(() => {
            this.doLayout();
            this.tablesReady = true;
          });
        });
      });
    },
    // 解决表头抖动
    doLayout() {
      this.$refs.priceTable && this.$refs.priceTable.doLayout();
      this.$refs.importPanel && this.$refs.importPanel.doLayout();
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-area {
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  gap: 22px;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.edit-panel {
  min-width: 0;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e1e7ef;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}

.edit-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.panel-head {
  display: flex;
  flex: 0 0 auto;
  min-width: 0;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

.panel-head > div {
  min-width: 0;
}

.panel-head > div:first-child {
  flex: 1 1 auto;
}

.method-title {
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
}

.method-title span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  color: #082dc3;
  background: #eef3ff;
  border-radius: 50%;
}

.panel-head p {
  margin: 8px 0 0 28px;
  color: #667085;
  font-size: 12px;
}

.panel-actions {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
  max-width: 560px;
}

.panel-actions .el-button {
  margin-left: 0;
}

.price-table-form {
  flex: 0 1 auto;
  min-height: 0;
  margin-bottom: 14px;
}

.price-table {
  visibility: hidden;
}

.price-table--ready {
  visibility: visible;
}

::v-deep .price-table-form .el-table th.el-table__cell {
  padding: 8px 0;
}

::v-deep .price-table-form .el-table td.el-table__cell {
  padding: 5px 0;
}

::v-deep .price-table-form .el-form-item {
  margin: 0;
}

::v-deep .price-table-form .el-form-item__content {
  line-height: 30px;
}

::v-deep .price-table-form .el-input__inner {
  height: 30px;
  line-height: 30px;
}

.primary-btn {
  background: #082dc3;
  border-color: #082dc3;
}

.primary-plain {
  color: #082dc3;
  border-color: #9cabe7;
}

.danger-text {
  color: #f04438;
}

.full-width {
  width: 100%;
}

::v-deep .adjustment-form .el-form-item {
  margin-bottom: 16px;
}

::v-deep .adjustment-form .el-form-item__label {
  padding: 0 0 6px;
  line-height: 18px;
  font-weight: 600;
}

.add-row {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 36px;
  margin-top: auto;
  padding: 0;
  font: inherit;
  color: #344054;
  cursor: pointer;
  background: #ffffff;
  border: 1px dashed #aeb8c6;
  border-radius: 4px;
  appearance: none;
}

.add-row:hover,
.add-row:focus {
  color: #082dc3;
  border-color: #9cabe7;
  outline: none;
}

.add-row i {
  margin-right: 6px;
}

</style>
